import { render, staticRenderFns } from "./register.vue?vue&type=template&id=0556a654&scoped=true&"
import script from "./register.vue?vue&type=script&lang=ts&"
export * from "./register.vue?vue&type=script&lang=ts&"
import style0 from "./register.vue?vue&type=style&index=0&id=0556a654&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0556a654",
  null
  
)

export default component.exports